// designer directory, project breadcrumbs, photo breadcrumbs
export const DIRECTORY_PATH = '/design-firms/';

export const PHOTOS_BROWSE_PAGE_LIMIT = 50;
